import { __extends } from "tslib";
import { ConsolidatedItemsPosition_$type } from "./ConsolidatedItemsPosition";
import { IgrHorizontalAnchoredCategorySeries } from "./igr-horizontal-anchored-category-series";
import { ColumnSeries } from "./ColumnSeries";
import { ensureEnum, toPoint, fromRect } from "igniteui-react-core";
/**
 * Represents a IgxDataChartComponent column series.
 * Compare values across categories by using vertical rectangles.
 * Use it when the order of categories is not important or for displaying
 * item counts such as a histogram.
*
* ```ts
*  <IgrDataChart
* 		ref={this.onChartRef}
*         dataSource={this.data}>
*
*         <IgrCategoryXAxis name="xAxisYears"/>
*         <IgrCategoryXAxis name="xAxisMonths" />
*         <IgrNumericYAxis  name="yAxisLeft"  />
*         <IgrNumericYAxis  name="yAxisRight" />
*
*         <IgrColumnSeries name="series1"
*         valueMemberPath="volume"
*         xAxisName="xAxisMonths"
*         yAxisName="yAxisLeft"
*         isTransitionInEnabled="true" />
* </IgrDataChart>
* ```
*
* ```ts
* 	this.columnSeries1 = new IgrColumnSeries({ name: "colSeries1" });
* 	this.columnSeries1.dataSource = this.categoryData;
* 	this.columnSeries1.xAxis = this.categoryXAxis;
* 	this.columnSeries1.yAxis = this.numericYAxis;
* 	this.columnSeries1.xAxisName = "categoryXAxis";
* 	this.columnSeries1.yAxisName = "numericYAxis";
* 	this.columnSeries1.valueMemberPath = "volume";
* ```
*/
var IgrColumnSeries = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrColumnSeries, _super);
    function IgrColumnSeries(props) {
        return _super.call(this, props) || this;
    }
    IgrColumnSeries.prototype.createImplementation = function () {
        return new ColumnSeries();
    };
    Object.defineProperty(IgrColumnSeries.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnSeries.prototype, "isColumn", {
        /**
         * Gets whether the current series shows a column shape.
        */
        get: function () {
            return this.i.dk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnSeries.prototype, "isMarkerlessDisplayPreferred", {
        /**
         * Overridden by derived series classes to indicate when marker-less display is preferred or not.
        */
        get: function () {
            return this.i.d5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnSeries.prototype, "radiusX", {
        /**
         * Gets or sets the x-radius of the ellipse that is used to round the corners of the column.
        */
        get: function () {
            return this.i.vn;
        },
        set: function (v) {
            this.i.vn = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnSeries.prototype, "radiusY", {
        /**
         * Gets or sets the y-radius of the ellipse that is used to round the corners of the column.
        */
        get: function () {
            return this.i.vo;
        },
        set: function (v) {
            this.i.vo = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrColumnSeries.prototype, "consolidatedColumnVerticalPosition", {
        /**
         * The positioning logic to use for columns which have been consolidated into a single visual element.
        */
        get: function () {
            return this.i.vl;
        },
        set: function (v) {
            this.i.vl = ensureEnum(ConsolidatedItemsPosition_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * If possible, will return the best available value bounding box within the series that has the best value match for the world position provided.
    
    * @param world  * The world coordinate for which to get a value bounding box for
    */
    IgrColumnSeries.prototype.getSeriesValueBoundingBox = function (world) {
        var iv = this.i.p3(toPoint(world));
        return fromRect(iv);
    };
    /**
     * For a category plotted series, returns the current width of the items within the categories. This only returns a value if the items have some form of width (e.g. columns, bars, etc.) otherwise 0 is returned.
    
    */
    IgrColumnSeries.prototype.getItemSpan = function () {
        var iv = this.i.ge();
        return (iv);
    };
    return IgrColumnSeries;
}(IgrHorizontalAnchoredCategorySeries));
export { IgrColumnSeries };
